export default {

  subtitle: "آشنایی با مسیر ما",
  title: "داستان ما؛ آغازی برای تغییر در آموزش نسل جدید",
  paragraph1:
    "بدون تردید نسل جدید که به نسل دیجیتال معروف است ارتباطی بیشتر از نسل‌های گذشته با فضای اینترنت دارد و بخش مهمی از نیازهای خود را از همین طریق برآورده می‌کند. بدیهی است که آموزش چنین نسلی هم در آینده از همین طریق خواهد بود که ما سعی کردیم آغازگر این تغییر ذائقه در آموزش زبان نسل جدید باشیم. ما اینجاییم تا ۲۰ سال تجربه آموزش زبان کودک و نوجوان خود را تبدیل به سفری ماجراجویانه کنیم تا آنان شکل جدیدی از آموزش را برای اولین بار در ایران تجربه کنند.",
  paragraph2:
    "همراهان ما در این سفر، کودکان و نوجوانان ۴ تا ۱۴ ساله خواهند بود تا در محیطی بدون استرس، آموزشی رنگارنگ را تجربه کنند؛ آموزشی که بنا دارد همانند آموزشگاهی در اتاق کودکان حضور داشته باشد تا تمام دوره‌های زبان را در فضای اینترنت آموزش دهد.",
  expNumber: "+۲۰ سال",
  expLabel: "تجربه آموزش کودک",
  ageNumber: "۴ تا ۱۴ سال",
  ageLabel: "مخاطبان همراه ما",
  pillText: "سفر به دنیای زبان",

  badge: "تیم رهبری و طراحان آموزشی",
  title2: "موسس و طراح دوره‌های زبان‌کید",
  subtitle2: "سناریو آموزشی تمام دوره‌ها توسط آقای محمد خالد فیضی طراحی و تدوین شده است.",
  name: "محمد خالد فیضی",
  role: "موسس zabankid و طراح سناریوهای آموزشی",
  bio: "دارای ۲۰ سال سابقه آموزشی و پژوهشی در حوزه زبان کودک، نوجوان و دانشگاهی با تاییده‌های بین‌المللی از کانادا و فنلاند.",
  achievements: [
    {
      text: "نفر اول جشنواره جهانی ican Canada بین ۸۰ کشور در بخش خلاقیت و نوآوری در آموزش",
      icon: "bi-trophy-fill",
      category: "cat-gold",
      tag: "بین‌المللی",
    },
    {
      text: "دارای مدرک کودک کارآفرین از دانشگاه تورکو فنلاند (برترین دانشگاه تربیت معلم جهان)",
      icon: "bi-mortarboard-fill",
      category: "cat-blue",
      tag: "دانشگاه فنلاند",
    },
    {
      text: "ابداع کننده روش جدید آموزش مهارت نوشتاری برای کودکان و ثبت رسمی آن در کانادا",
      icon: "bi-lightbulb-fill",
      category: "cat-purple",
      tag: "ابداع و ثبت اختراع",
    },
    {
      text: "نفر اول جشنواره بین‌المللی رومانی در بخش خلاقیت و نوآوری در آموزش",
      icon: "bi-star-fill",
      category: "cat-gold",
      tag: "بین‌المللی",
    },
    {
      text: "نفر اول جشنواره بین‌المللی لهستان INTARG 2022 در بخش خلاقیت و نوآوری",
      icon: "bi-award-fill",
      category: "cat-gold",
      tag: "لهستان ۲۰۲۲",
    },
    {
      text: "تقدیر شده از طرف سازمان جهانی مخترعین آمریکا (Wiipa)",
      icon: "bi-shield-check",
      category: "cat-blue",
      tag: "آمریکا (Wiipa)",
    },
    {
      text: "دارای گواهی‌نامه بین‌المللی Spark Center کانادا",
      icon: "bi-patch-check-fill",
      category: "cat-blue",
      tag: "کانادا",
    },
    {
      text: "مولف ۷ جلد کتاب‌های Joy Phonics مخصوص آموزش زبان انگلیسی کودکان (با همکاری انتشارات رهنما)",
      icon: "bi-book-half",
      category: "cat-green",
      tag: "تالیف کتاب",
    },
    {
      text: "مولف کتاب آموزش زبان انگلیسی فیض و تایید آن توسط سازمان پژوهش و برنامه‌ریزی کتب درسی کشور",
      icon: "bi-journal-check",
      category: "cat-green",
      tag: "کتب درسی کشور",
    },
    {
      text: "مولف کتاب آموزش الفبای انگلیسی برای کودکان با همکاری انتشارات جنگل",
      icon: "bi-bookshelf",
      category: "cat-green",
      tag: "انتشارات جنگل",
    },
    {
      text: "مولف کتاب‌های آموزش زبان انگلیسی KEB برای کودکان و کتاب دانشگاهی انگلیسی عمومی",
      icon: "bi-collection-play-fill",
      category: "cat-green",
      tag: "کتب کودکان و دانشگاهی",
    },
    {
      text: "ترجمه کتاب اصول عکاسی با تایید سازمان پژوهش و برنامه‌ریزی کتب درسی کشور",
      icon: "bi-camera-reels-fill",
      category: "cat-cyan",
      tag: "ترجمه رسمی",
    },
    {
      text: "مولف کتاب دوزبانه تاریخ ترجمه انگلیسی در دوره قاجار و مقاله در نشریه ادب فارسی دانشگاه تهران",
      icon: "bi-journal-richtext",
      category: "cat-cyan",
      tag: "پژوهش دانشگاه تهران",
    },
    {
      text: "مدرس خوشنویسی انگلیسی در مرکز خوشنویسی بین‌الملل",
      icon: "bi-pen-fill",
      category: "cat-purple",
      tag: "تدریس تخصصی",
    },
    {
      text: "دارای گواهینامه تئوری انتخاب در بخش آموزش و موسس انتشارات کاردو",
      icon: "bi-building-check",
      category: "cat-purple",
      tag: "مدیریت و نشر",
    },
    {
      text: "بیست سال سابقه فعالیت مستمر در آموزش تخصصی زبان انگلیسی در تهران",
      icon: "bi-calendar-check-fill",
      category: "cat-blue",
      tag: "۲۰ سال سابقه",
    },
  ],

};
